import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=3f4d9519"
import script from "./AdminCategories.vue?vue&type=script&lang=js"
export * from "./AdminCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports